import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    InputAdornment,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    SelectChangeEvent,
    TextField,
    Typography,
    styled,
    IconButton,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import * as React from "react";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../api/ApiCall";
import { userLogging } from "../../../utility/firestore";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
    StoreOpeningConditionsTypeList,
    StoreOpeningConditionsBooleanTypeList,
    StoreOpeningConditionsStringTypeList,
    initStoreOpeningConditionsCommentTextFieldObj,
    initStoreOpeningConditionsReadOnlyObj,
    initStoreOpeningConditionsShowEditIconObj,
    initStoreOpeningConditionsShowIconObj,
} from "../../../data/type";
import {
    setSaveStatus,
    setDeleteRequestErrorList
} from "../../../features/longPageSlice";
import {
    setObjStoreOpeningConditions,
    setShowPreviousJob,
    setStoreOpeningConditionsLongTextShow,
} from "../../../features/storeOpeningConditionsSlice";
import { useUserContext } from "../../../user-provider";
import { useUtilityContext } from "../../../utility-provider";
import { LOCAL_CONSTANT } from "../../Const";
import InputWithIcons from "../../components/InputWithIcons";
import {
    chatBubbleErrorSx,
    chatBubbleIconSx,
    editIconCircleSx,
    iconHover,
} from "../../components/ChatBubbleAndEditIconStyle";
import LongTextFiledWithIcons from "../../components/LongTextFiledWithIcons";
import { mojiLimit } from "../../components/MojiLimit";
import {
    inactiveTextSx,
    inactiveBlueTextSx,
} from "../../components/TextFieldStyle";
import { setPermissionFunc } from "../../components/PermissionFunc";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import EditIcon from "@mui/icons-material/Edit";
import DeficiencyCommentRegistModal from "../../components/DeficiencyCommentRegistModal";
import {
    changeTextColor,
    changeNoSubkeyBGColor,
    changeCheckBoxBGColor,
    changeNoSubkeyCheckBoxBGColor,
    changeBorderColor,
    changeStoreOpeningConditionsBGColor
} from "../../../data/tableFunc";
import {
    BorderDefaultColor,
    BorderHoverColor,
    BorderFocusedColor,
    BorderErrorColor
} from "../../../data/table";

//項目値の横幅調整
const itemValueSx = {
    width: "250px",
};

//24時間営業、酒免許、煙草免許のプルダウン スタイル
const selectMonthStyle = (
    isUserType: boolean,
    objRrBranchLog: any,
    objRequestErrorList: any,
    listDeficiencyComment: any,
    labelName: string,
    value: any
) => {
    //テキストカラー
    const color = changeTextColor(
        isUserType,
        objRrBranchLog,
        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
        labelName
    );
    //背景
    const backgroundColor = changeNoSubkeyBGColor(
        isUserType,
        objRequestErrorList,
        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
        labelName,
        value
    );
    //枠線
    const hasBorderColor = changeBorderColor(
        listDeficiencyComment,
        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
        labelName
    );
    return {
        "& .MuiSelect-icon": {
            display: "none",
        },
        "& .MuiSelect-select": {
            color: color,
            textAlign: "center",
            paddingRight: "0px !important",
        },
        "& .Mui-disabled": {
            WebkitTextFillColor: color
        },
        backgroundColor: backgroundColor,
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderDefaultColor,
            borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整

        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderHoverColor,    //ホバー時
            borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整

        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderFocusedColor,  //フォーカス時
            borderWidth: hasBorderColor ? "3pt" : "2pt"                           //線の幅調整

        },
        "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderDefaultColor,  //非活性時
            borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整
        }
    };
};

// プルダウン スタイル
const selectStyle = (
    isUserType: boolean,
    objRrBranchLog: any,
    objRequestErrorList: any,
    listDeficiencyComment: any,
    labelName: string,
    value: any,
    objLocationBase: any
) => {
    //テキストカラー
    const color = changeTextColor(
        isUserType,
        objRrBranchLog,
        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
        labelName
    );
    //背景
    let backgroundColor
    // S店(セットバック、立地調査)の出店条件の一部入力欄グレーアウト化
    const targetLocationType = ["06", "07", "08", "09"];
    if(
        (objLocationBase.plan_area_id.startsWith("X") || objLocationBase.plan_area_id.startsWith("Y")) &&
        (targetLocationType.includes(objLocationBase.location_type))
    ) {
        backgroundColor = changeStoreOpeningConditionsBGColor(
            isUserType,
            objRequestErrorList,
            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
            labelName,
            value
        );
    } else {
        backgroundColor = changeNoSubkeyBGColor(
            isUserType,
            objRequestErrorList,
            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
            labelName,
            value
        );
    }
    //枠線
    const hasBorderColor = changeBorderColor(
        listDeficiencyComment,
        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
        labelName
    );
    return {
        "& .MuiSelect-select": {
            color: color
        },
        "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled": {
            WebkitTextFillColor: color
        },
        textAlign: "center",
        backgroundColor: backgroundColor,
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderDefaultColor,
            borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderHoverColor,    //ホバー時
            borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderFocusedColor,  //フォーカス時
            borderWidth: hasBorderColor ? "3pt" : "2pt"                           //線の幅調整

        },
        "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderDefaultColor,  //非活性時
            borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整
        }
    };
};

//チェックボックス スタイル
const checkboxStyle = (
    isUserType: boolean,
    objRrBranchLog: any,
    objRequestErrorList: any,
    labelName: string,
    value: any
) => {
    //テキストカラー
    const color = changeTextColor(
        isUserType,
        objRrBranchLog,
        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
        labelName
    );
    return {
        "& .MuiFormControlLabel-label": {
            color: color
        },
        "& .MuiFormControlLabel-label.Mui-disabled": {
            color: color
        },
        backgroundColor: changeNoSubkeyCheckBoxBGColor(
            isUserType,
            objRequestErrorList,
            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
            labelName,
            value
        ),
    };
};

//チェックボックス 複合店舗
const checkboxStoreStyle = (
    isUserType: boolean,
    objRrBranchLog: any,
    labelName: string,
    value: any
) => {
    // テキストカラー
    const color = changeTextColor(
        isUserType,
        objRrBranchLog,
        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
        labelName
    );
    return {
        "& .MuiFormControlLabel-label": {
            color: color,
            width: "80px",
        },
        "& .MuiFormControlLabel-label.Mui-disabled": {
            color: color,
            width: "80px",
        },
        backgroundColor: changeCheckBoxBGColor(isUserType, value),
    };
};

//ラジオボタン スタイル
const radioStyle = (isUserType: boolean) => {
    return {
        color: isUserType ? "gray" : "orange", //未選択時の色指定
        "&.Mui-checked": {
            color: isUserType ? "gray" : "orange", //選択時の色指定
        },
    };
};

//候補地跡地のプルダウン値
const candidateLocationRuinsItems: { [key: string]: string } = {
    candidateLocationRuinsItem1: "なし",
    candidateLocationRuinsItem2: "自社建替え",
    candidateLocationRuinsItem3: "自社跡地",
    candidateLocationRuinsItem4: "競合看板替え",
    candidateLocationRuinsItem5: "競合跡地",
};

//地域区分のプルダウン値
const areaTypeItems: { [key: string]: string } = {
    areaTypeItem1: "指定都市",
    areaTypeItem2: "市制施行地",
    areaTypeItem3: "町村制施行地",
};

//month
const monthItems: { [key: string]: string } = {
    monthItems1: "0",
    monthItems2: "1",
    monthItems3: "2",
    monthItems4: "3",
    monthItems5: "4",
    monthItems6: "5",
    monthItems7: "6",
    monthItems8: "7",
    monthItems9: "8",
    monthItems10: "9",
    monthItems11: "10",
    monthItems12: "11",
    monthItems13: "12",
};

//アスタリスク
const RedAsterisk = styled("span")({
    color: "red",
    marginLeft: "4px",
    display: "flex",
    alignItems: "center",
});

interface SettingReasonProps {
    props: {
        storeOpeningConditions: StoreOpeningConditionsTypeList;
        setStoreOpeningConditions: React.Dispatch<
            React.SetStateAction<StoreOpeningConditionsTypeList>
        >;
    };
}

export const SettingReason: React.FC<SettingReasonProps> = ({ props }) => {
    const objStoreOpeningConditions = useAppSelector(
        (state) => state.storeOpeningConditions.obj
    );
    const showPreviousJob = useAppSelector(
        (state) => state.storeOpeningConditions.showPreviousJob
    );
    //調査種別プルダウンの値を取得
    const selectedSurveyType = useAppSelector(
        (state) => state.longPage.surveyType
    );
    //ロングテキストを表示非表示のステータスを取得
    const objLongTextShow = useAppSelector(
        (state) => state.storeOpeningConditions.showLongText
    );
    //ロングページオブジェクト 候補地NOと枝を取得
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    //ステータス管理sequenceとタスクIDを取得するため
    const objLocationBase = useAppSelector(
        (state) => state.longPage.locationBase
    );
    //パラメーターオブジェクト
    const objLongPageSaveStatus = useAppSelector(
        (state) => state.longPage.saveStatus
    );
    // 表示色変更用BQログデータ
    const objRrBranchLog = useAppSelector(
        (state) => state.longPage.rrBranchLog
    );
    // 入力チェックエラーリスト
    const objRequestErrorList = useAppSelector(
        (state) => state.longPage.requestErrorList
    );
    // 不備コメントリスト
    const listDeficiencyComment = useAppSelector(
        (state) => state.deficiencyComment
    );
    //取得要件 項目権限 非活性のため初期はtrue
    const [isAcquisitionRequirement, setIsAcquisitionRequirement] =
        useState<boolean>(true);
    //移転 ラジオボタン右のテキストフィールド権限 非活性のため初期はtrue
    const [isStoreMoveDistance, setIsStoreMoveDistance] =
        useState<boolean>(true);
    //不備コメントモーダルラベル名
    const [labelNameStr, setLabelNameStr] = useState<string>("");
    //不備コメントモーダル開閉フラグ
    const [deficiencyComentModalFlag, setDeficiencyComentModalFlag] =
        useState(false);
    //アイコン全体の表示非表示のステータス
    const [
        storeOpeningConditionsShowIconsObj,
        setStoreOpeningConditionsShowIconsObj,
    ] = useState<StoreOpeningConditionsBooleanTypeList>(
        initStoreOpeningConditionsShowIconObj
    );
    //不備コメントモーダル内、TextFieldのコメント
    const [
        storeOpeningConditionsCommentTextFieldObj,
        setStoreOpeningConditionsCommentTextFieldObj,
    ] = useState<StoreOpeningConditionsStringTypeList>(
        initStoreOpeningConditionsCommentTextFieldObj
    );
    //項目値を編集可能にするステータスの型定義
    const [
        storeOpeningConditionsReadOnlyObj,
        setStoreOpeningConditionsReadOnlyObj,
    ] = useState<StoreOpeningConditionsBooleanTypeList>(
        initStoreOpeningConditionsReadOnlyObj
    );

    //ユーザー種別を格納
    const [userType, setUserType] = useState("");

    //コードマスタ
    const [previousJob, setPreviousJob] = useState<any>(); //前職
    const [ownershipType, setOwnershipType] = useState<any>(); //所有形態
    const [storeType, setStoreType] = useState<any>(); //店舗形態
    const [environmentType, setEnvironmentType] = useState<any>(); //環境区分
    const [acquisitionRequirement, setAcquisitionRequirement] = useState<any>(); //取得要件
    const [storeMoveType, setStoreMoveType] = useState<any>(); //既存店敷地移転区分

    const user = useUserContext();
    const utilityCtx = useUtilityContext();
    const dispatch = useAppDispatch();

    //インプット
    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        labelName: string
    ) => {
        const targetValue = e.target.value; //入力値
        const storeOpeningConditionsValue =
            props.storeOpeningConditions[labelName];
        const regexRange0To20 = /^(|0|20|1\d{1}|[1-9])$/; //入力規則:整数 範囲:0～20
        const regexRange0To9999 = /^(|0|[1-9][0-9]{0,3})$/; //入力規則:整数 範囲:0～9999

        switch (labelName) {
            case "setting_reason": //ゾーン設定の理由
                props.setStoreOpeningConditions({
                    ...props.storeOpeningConditions,
                    [labelName]: mojiLimit(targetValue, 180),
                });
                break;
            case "candidate_location_ruins_long_text": //候補地跡地の理由
                props.setStoreOpeningConditions({
                    ...props.storeOpeningConditions,
                    [labelName]: mojiLimit(targetValue, 120),
                });
                break;
            case "removal_Reason": //店名選定の理由
                props.setStoreOpeningConditions({
                    ...props.storeOpeningConditions,
                    [labelName]: mojiLimit(targetValue, 120),
                });
                break;
            case "nearest_already_store_distance": // 最寄り既設店までの距離
                if (regexRange0To9999.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "distance_standard_alreadystore_count": //距離基準内の既設店舗数
                if (regexRange0To20.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "cvs_last_nippan": //前職 CVS直近日販
                if (regexRange0To9999.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "store_move_distance": //前職 移転距離
                if (regexRange0To9999.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            default:
                props.setStoreOpeningConditions({
                    ...props.storeOpeningConditions,
                    [labelName]: targetValue,
                });
                break;
        }

        //更新フラグ
        if (!objLongPageSaveStatus.StoreOpeningConditions)
            dispatch(
                setSaveStatus({
                    ...objLongPageSaveStatus,
                    StoreOpeningConditions: true,
                })
            );
    };

    //Redux チェックボックス
    const handleCheckBoxChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        labelName: string
    ) => {
        // 所在地表示以外にて選定にチェックを入れた時　下にロングテキストを表示
        if (labelName === "is_store_name_select_reason") {
            dispatch(
                setStoreOpeningConditionsLongTextShow({
                    ...objLongTextShow,
                    removal_Reason: e.target.checked,
                })
            );
        }
        // 入力した値をStoreへ登録する
        dispatch(
            setObjStoreOpeningConditions({
                ...objStoreOpeningConditions,
                [labelName]: e.target.checked,
            })
        );
        //更新フラグ
        if (!objLongPageSaveStatus.StoreOpeningConditions)
            dispatch(
                setSaveStatus({
                    ...objLongPageSaveStatus,
                    StoreOpeningConditions: true,
                })
            );
        //入力チェックのエラーリストから削除
        if (objRequestErrorList.length > 0)
            dispatch(
                setDeleteRequestErrorList({
                    page: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                    column: labelName,
                })
            );
    };

    //Redux プルダウン
    const handleSelectChange = (
        e: SelectChangeEvent<string>,
        labelName: string
    ) => {
        // 候補地跡地の項目値が変更したら、前職のテキストフィールドを更新
        if (labelName === "candidate_location_ruins") {
            // 候補地跡地のプルダウンが「なし」、「自社建替え」、「自社跡地」の場合は前職を非表示
            if (e.target.value === "なし") {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        [labelName]: e.target.value,
                        previous_job: "",
                    })
                );
                dispatch(setShowPreviousJob(false));
                // 候補地跡地のプルダウンの下にロングテキストを非表示
                dispatch(
                    setStoreOpeningConditionsLongTextShow({
                        ...objLongTextShow,
                        candidate_location_ruins: false,
                    })
                );
            } else if (
                e.target.value === "自社建替え" ||
                e.target.value === "自社跡地"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        [labelName]: e.target.value,
                        previous_job: "1",
                    })
                );
                dispatch(setShowPreviousJob(false));
                // 候補地跡地のプルダウンの下にロングテキストを表示
                dispatch(
                    setStoreOpeningConditionsLongTextShow({
                        ...objLongTextShow,
                        candidate_location_ruins: true,
                    })
                );
                // 候補地跡地のプルダウンが「競合看板替え」、「競合跡地」の場合は前職の「候補地が競合跡地」のみ表示
            } else if (
                e.target.value === "競合看板替え" ||
                e.target.value === "競合跡地"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        [labelName]: e.target.value,
                        previous_job: "0",
                    })
                );
                dispatch(setShowPreviousJob(true));
                // 候補地跡地のプルダウンの下にロングテキストを表示
                dispatch(
                    setStoreOpeningConditionsLongTextShow({
                        ...objLongTextShow,
                        candidate_location_ruins: true,
                    })
                );
            }
        } else {
            // 入力した値をStoreへ登録する
            dispatch(
                setObjStoreOpeningConditions({
                    ...objStoreOpeningConditions,
                    [labelName]: e.target.value,
                })
            );
        }

        //煙草距離基準 マトリックス値
        if (labelName === "area_type" || labelName === "environment_type") {
            //指定都市かつ繁華街（A）の場合、25
            if (
                objStoreOpeningConditions.area_type === "指定都市" &&
                e.target.value === "0"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "25",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "0" &&
                e.target.value === "指定都市"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "25",
                        [labelName]: e.target.value,
                    })
                );
                //指定都市かつ繁華街（B）の場合、50
            } else if (
                objStoreOpeningConditions.area_type === "指定都市" &&
                e.target.value === "1"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "50",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "1" &&
                e.target.value === "指定都市"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "50",
                        [labelName]: e.target.value,
                    })
                );
                //指定都市かつ市街地の場合、100
            } else if (
                objStoreOpeningConditions.area_type === "指定都市" &&
                e.target.value === "2"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "100",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "2" &&
                e.target.value === "指定都市"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "100",
                        [labelName]: e.target.value,
                    })
                );
                //指定都市かつ住宅地（A）の場合、200
            } else if (
                objStoreOpeningConditions.area_type === "指定都市" &&
                e.target.value === "3"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "200",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "3" &&
                e.target.value === "指定都市"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "200",
                        [labelName]: e.target.value,
                    })
                );
                //指定都市かつ住宅地（B）の場合、300
            } else if (
                objStoreOpeningConditions.area_type === "指定都市" &&
                e.target.value === "4"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "300",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "4" &&
                e.target.value === "指定都市"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "300",
                        [labelName]: e.target.value,
                    })
                );
                //市制施行地かつ繁華街（A）の場合、50
            } else if (
                objStoreOpeningConditions.area_type === "市制施行地" &&
                e.target.value === "0"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "50",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "0" &&
                e.target.value === "市制施行地"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "50",
                        [labelName]: e.target.value,
                    })
                );
                //市制施行地かつ繁華街（B）の場合、100
            } else if (
                objStoreOpeningConditions.area_type === "市制施行地" &&
                e.target.value === "1"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "100",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "1" &&
                e.target.value === "市制施行地"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "100",
                        [labelName]: e.target.value,
                    })
                );
                //市制施行地かつ市街地の場合、150
            } else if (
                objStoreOpeningConditions.area_type === "市制施行地" &&
                e.target.value === "2"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "150",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "2" &&
                e.target.value === "市制施行地"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "150",
                        [labelName]: e.target.value,
                    })
                );
                //市制施行地かつ住宅地（A）の場合、200
            } else if (
                objStoreOpeningConditions.area_type === "市制施行地" &&
                e.target.value === "3"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "200",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "3" &&
                e.target.value === "市制施行地"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "200",
                        [labelName]: e.target.value,
                    })
                );
                //市制施行地かつ住宅地（B）の場合、300
            } else if (
                objStoreOpeningConditions.area_type === "市制施行地" &&
                e.target.value === "4"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "300",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "4" &&
                e.target.value === "市制施行地"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "300",
                        [labelName]: e.target.value,
                    })
                );
                //町村制施行地かつ繁華街（A）の場合、空白
            } else if (
                objStoreOpeningConditions.area_type === "町村制施行地" &&
                e.target.value === "0"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "0" &&
                e.target.value === "町村制施行地"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "",
                        [labelName]: e.target.value,
                    })
                );
                //町村制施行地かつ繁華街（A）の場合、空白
            } else if (
                objStoreOpeningConditions.area_type === "町村制施行地" &&
                e.target.value === "0"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "0" &&
                e.target.value === "町村制施行地"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "",
                        [labelName]: e.target.value,
                    })
                );
                //町村制施行地かつ繁華街（B）の場合、空白
            } else if (
                objStoreOpeningConditions.area_type === "町村制施行地" &&
                e.target.value === "1"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "1" &&
                e.target.value === "町村制施行地"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "",
                        [labelName]: e.target.value,
                    })
                );
                //町村制施行地か市街地の場合、150
            } else if (
                objStoreOpeningConditions.area_type === "町村制施行地" &&
                e.target.value === "2"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "150",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "2" &&
                e.target.value === "町村制施行地"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "150",
                        [labelName]: e.target.value,
                    })
                );
                //町村制施行地か住宅地（A）の場合、200
            } else if (
                objStoreOpeningConditions.area_type === "町村制施行地" &&
                e.target.value === "3"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "200",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "3" &&
                e.target.value === "町村制施行地"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "200",
                        [labelName]: e.target.value,
                    })
                );
                //町村制施行地か住宅地（B）の場合、300
            } else if (
                objStoreOpeningConditions.area_type === "町村制施行地" &&
                e.target.value === "4"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "300",
                        [labelName]: e.target.value,
                    })
                );
            } else if (
                objStoreOpeningConditions.environment_type === "4" &&
                e.target.value === "町村制施行地"
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        tobacco_distance_standard: "300",
                        [labelName]: e.target.value,
                    })
                );
            }
        }
        //更新フラグ
        if (!objLongPageSaveStatus.StoreOpeningConditions)
            dispatch(
                setSaveStatus({
                    ...objLongPageSaveStatus,
                    StoreOpeningConditions: true,
                })
            );
        //入力チェックのエラーリストから削除
        if (objRequestErrorList.length > 0)
            dispatch(
                setDeleteRequestErrorList({
                    page: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                    column: labelName,
                })
            );
    };

    //Redux ラジオボタン
    const handleRadioButtonChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        labelName: string
    ) => {
        // 入力した値をStoreへ登録する
        dispatch(
            setObjStoreOpeningConditions({
                ...objStoreOpeningConditions,
                [labelName]: e.target.value,
            })
        );
        //更新フラグ
        if (!objLongPageSaveStatus.StoreOpeningConditions)
            dispatch(
                setSaveStatus({
                    ...objLongPageSaveStatus,
                    StoreOpeningConditions: true,
                })
            );
        //入力チェックのエラーリストから削除
        if (objRequestErrorList.length > 0)
            dispatch(
                setDeleteRequestErrorList({
                    page: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                    column: labelName,
                })
            );
    };

    //インプットをクリックしたときアイコンを表示
    const handleInputClick = (labelName: string) => {
        setStoreOpeningConditionsShowIconsObj({
            ...storeOpeningConditionsShowIconsObj,
            [labelName]: true,
        });
    };

    // 吹き出しをクリックしたとき、モーダル画面を開く
    const handleChatBubbleClick = (labelName: string) => {
        setLabelNameStr(labelName);
        setDeficiencyComentModalFlag(true);
        setStoreOpeningConditionsCommentTextFieldObj({
            ...storeOpeningConditionsCommentTextFieldObj,
            [labelName]: "",
        }); //テキストフィールドのコメントを初期化
    };

    //不備コメントモーダル内でのコメント取得
    const handleCommentChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        labelName: string
    ) => {
        setStoreOpeningConditionsCommentTextFieldObj({
            ...storeOpeningConditionsCommentTextFieldObj,
            [labelName]: e.target.value,
        });
    };

    //不備コメントモーダル内の保存ボタンをクリックしたとき不備コメントを保存
    const handleSaveComment = async (labelName: string) => {
        //不備コメントを登録
        const params = {
            mode: "regist",
            endPoint: "/location/Deficiency/v1/regist",
            query: {
                plan_area_id: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                status_seq: objLocationBase.status_seq,
                table_name: LOCAL_CONSTANT.TABLE.STORE_OPENING_CONDITIONS,
                column_name: labelName,
                comment: storeOpeningConditionsCommentTextFieldObj[labelName],
                sub_key: LOCAL_CONSTANT.DEFICIENCY.DEFAULT_SUB_KEY
            },
        };
        userLogging(
            LOCAL_CONSTANT.FUNCTION_NAME.SETTING_REASON_COMMENT,
            params,
            user
        );
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        try {
            await apiRequest(params);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            //不備コメントモーダルを閉じる
            setDeficiencyComentModalFlag(false);
            //アイコンを非表示
            setStoreOpeningConditionsShowIconsObj({
                ...storeOpeningConditionsShowIconsObj,
                [labelName]: false,
            });
        } catch (e) {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            //不備コメントモーダルを閉じる
            setDeficiencyComentModalFlag(false);
            //アイコンを非表示
            setStoreOpeningConditionsShowIconsObj({
                ...storeOpeningConditionsShowIconsObj,
                [labelName]: false,
            });
        }
    };

    // 鉛筆をクリックしたとき、Input編集可
    const handleEditIconClick = (labelName: string) => {
        if (
            setPermissionFunc(
                userType,
                objLocationBase.task_id,
                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                labelName
            ) === false
        ) {
            //falseにすると、Input編集可
            setStoreOpeningConditionsReadOnlyObj({
                ...storeOpeningConditionsReadOnlyObj,
                [labelName]: false,
            });
            if (labelName === "acquisition_requirement") {
                setIsAcquisitionRequirement(false);
            }
        }
    };

    // インプットからフォーカスがずれたら、インプット編集不可とアイコンを非表示にする
    const handleInputBlur = (
        e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>,
        labelName: string
    ) => {
        //Reduxへ保存
        dispatch(
            setObjStoreOpeningConditions({
                ...props.storeOpeningConditions,
                [labelName]: e.target.value,
            })
        );

        //入力チェックのエラーリストから削除
        if (objRequestErrorList.length > 0)
            dispatch(
                setDeleteRequestErrorList({
                    page: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                    column: labelName,
                })
            );

        // インプット編集不可
        setStoreOpeningConditionsReadOnlyObj({
            ...storeOpeningConditionsReadOnlyObj,
            [labelName]: true,
        });

        //インプットからフォーカスが移動する先がnullの場合アイコンを閉じる
        if (!e.relatedTarget) {
            setStoreOpeningConditionsShowIconsObj({
                ...storeOpeningConditionsShowIconsObj,
                [labelName]: false,
            });
        }

        //インプットからフォーカスが移動する先がインプットタグの場合アイコンを閉じる
        if (e.relatedTarget && e.relatedTarget.tagName === "INPUT") {
            setStoreOpeningConditionsShowIconsObj({
                ...storeOpeningConditionsShowIconsObj,
                [labelName]: false,
            });
        }

        //テキストエリアからフォーカスが移動する先がテキストエリアタグの場合アイコンを閉じる
        if (e.relatedTarget && e.relatedTarget.tagName === "TEXTAREA") {
            setStoreOpeningConditionsShowIconsObj({
                ...storeOpeningConditionsShowIconsObj,
                [labelName]: false,
            });
        }
    };

    //ロングテキスト入力制御
    const handleKeyDown = (e: any, labelName: string) => {
        if (
            labelName === "setting_reason" &&
            e.key === "Enter" &&
            e.target.value.split("\n").length >= 3
        ) {
            e.preventDefault();
        } else if (
            labelName === "candidate_location_ruins_long_text" &&
            e.key === "Enter" &&
            e.target.value.split("\n").length >= 2
        ) {
            e.preventDefault();
        } else if (
            labelName === "removal_Reason" &&
            e.key === "Enter" &&
            e.target.value.split("\n").length >= 2
        ) {
            e.preventDefault();
        }
    };

    //コードマスタ取得
    useEffect(() => {
        const res: any = localStorage.getItem("codeMaster");
        if (res) {
            const d = JSON.parse(res);
            //コードマスター
            setPreviousJob(d["previous_job"]); //前職
            setOwnershipType(d["ownership_type"]); //所有形態
            setStoreType(d["store_type"]); //店舗形態
            setEnvironmentType(d["environment_type"]); //環境区分
            setAcquisitionRequirement(d["acquisition_requirement"]); //取得要件
            setStoreMoveType(d["store_move_type"]); //既存店敷地移転区分
        }
    }, []);

    //ユーザー取得タイミングによる画面制御
    useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserType(JSON.parse(user.userData || "null").user_type);
        }
    }, [user]);

    //取得要件 項目の権限
    useEffect(() => {
        const permisson: boolean = setPermissionFunc(
            userType,
            objLocationBase.task_id,
            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
            "acquisition_requirement"
        );
        if (userType === LOCAL_CONSTANT.USER_TYPE.RFC) {
            //RFC
            if (permisson === true) {
                //非活性の場合は、空になる処理のみ実施
                setIsAcquisitionRequirement(true); ////取得要件 非活性
                //最寄既設店までの距離が空の場合 取得要件を空に設定
                if (
                    objStoreOpeningConditions.nearest_already_store_distance === ""
                ) {
                    dispatch(
                        setObjStoreOpeningConditions({
                            ...objStoreOpeningConditions,
                            acquisition_requirement: "",
                        })
                    ); //空
                    //煙草免許(無)が12か月の場合 取得要件を空に設定
                } else if (
                    12 - Number(objStoreOpeningConditions.tobacco_licence) ===
                    12
                ) {
                    dispatch(
                        setObjStoreOpeningConditions({
                            ...objStoreOpeningConditions,
                            acquisition_requirement: "",
                        })
                    ); //空
                    //煙草免許(無)が12か月未満かつ煙草距離基準 < 最寄既設店までの距離の場合 不要項目
                } else if (
                    12 - Number(objStoreOpeningConditions.tobacco_licence) <
                    12 &&
                    Number(objStoreOpeningConditions.tobacco_distance_standard) <
                    Number(
                        objStoreOpeningConditions.nearest_already_store_distance
                    )
                ) {
                    dispatch(
                        setObjStoreOpeningConditions({
                            ...objStoreOpeningConditions,
                            acquisition_requirement: "",
                        })
                    ); //空
                }
            }
            if (permisson === false) {
                //活性の場合
                setIsAcquisitionRequirement(false); //取得要件 活性
                //最寄既設店までの距離が空の場合 取得要件を非活性化＆空に設定
                if (
                    objStoreOpeningConditions.nearest_already_store_distance === ""
                ) {
                    setIsAcquisitionRequirement(true); //非活性
                    dispatch(
                        setObjStoreOpeningConditions({
                            ...objStoreOpeningConditions,
                            acquisition_requirement: "",
                        })
                    ); //空
                    //煙草免許(無)が12か月の場合　取得要件を非活性化＆空に設定
                } else if (
                    12 - Number(objStoreOpeningConditions.tobacco_licence) ===
                    12
                ) {
                    setIsAcquisitionRequirement(true); //非活性
                    dispatch(
                        setObjStoreOpeningConditions({
                            ...objStoreOpeningConditions,
                            acquisition_requirement: "",
                        })
                    ); //空
                    //煙草免許(無)が12か月未満かつ煙草距離基準 < 最寄既設店までの距離の場合 不要項目
                } else if (
                    12 - Number(objStoreOpeningConditions.tobacco_licence) <
                    12 &&
                    Number(objStoreOpeningConditions.tobacco_distance_standard) <
                    Number(
                        objStoreOpeningConditions.nearest_already_store_distance
                    )
                ) {
                    setIsAcquisitionRequirement(true); //非活性
                    dispatch(
                        setObjStoreOpeningConditions({
                            ...objStoreOpeningConditions,
                            acquisition_requirement: "",
                        })
                    ); //空
                } else {
                    setIsAcquisitionRequirement(false); //活性
                }
            }
        }
        if (userType === LOCAL_CONSTANT.USER_TYPE.RR) {
            //リサーチ
            setIsAcquisitionRequirement(true); //取得要件 非活性
            //最寄既設店までの距離が空の場合 取得要件を空に設定
            if (objStoreOpeningConditions.nearest_already_store_distance === "") {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        acquisition_requirement: "",
                    })
                ); //空
                //煙草免許(無)が12か月の場合 取得要件を空に設定
            } else if (
                12 - Number(objStoreOpeningConditions.tobacco_licence) ===
                12
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        acquisition_requirement: "",
                    })
                ); //空
                //煙草免許(無)が12か月未満かつ煙草距離基準 < 最寄既設店までの距離の場合 不要項目
            } else if (
                12 - Number(objStoreOpeningConditions.tobacco_licence) < 12 &&
                Number(objStoreOpeningConditions.tobacco_distance_standard) <
                Number(
                    objStoreOpeningConditions.nearest_already_store_distance
                )
            ) {
                dispatch(
                    setObjStoreOpeningConditions({
                        ...objStoreOpeningConditions,
                        acquisition_requirement: "",
                    })
                ); //空
            }
        }
    }, [
        objStoreOpeningConditions.nearest_already_store_distance,
        objStoreOpeningConditions.tobacco_distance_standard,
        objStoreOpeningConditions.tobacco_licence,
        userType,
    ]);

    //移転 ラジオボタン右のテキストフィールド権限
    useEffect(() => {
        if (objStoreOpeningConditions.store_move_type === "1") {
            const permisson: boolean = setPermissionFunc(
                userType,
                objLocationBase.task_id,
                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                "store_move_distance"
            );
            if (permisson === true) {
                //非活性の場合
                setIsStoreMoveDistance(true); //非活性
            }
            if (permisson === false) {
                //活性の場合
                setIsStoreMoveDistance(false); //活性
            }
        } else {
            setIsStoreMoveDistance(true);
        }
    }, [objStoreOpeningConditions.store_move_type, userType]);

    useEffect(() => {
        //ReduxをuseStateに保存
        props.setStoreOpeningConditions(objStoreOpeningConditions);
    }, [objStoreOpeningConditions]);

    //不備コメントモーダルを閉じたときに、吹き出しと鉛筆アイコンを非表示
    useEffect(() => {
        if (!deficiencyComentModalFlag) {
            setStoreOpeningConditionsShowIconsObj({
                ...initStoreOpeningConditionsShowIconObj
            });
        }
    }, [deficiencyComentModalFlag]);

    return (
        <Box>
            <Typography component="h2" mt={2}>
                １．設定の理由について
            </Typography>

            <Grid container spacing={2}>
                <Grid xs={12}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "120px",
                                }}
                            >
                                <Typography>ゾーン設定の理由</Typography>
                                {/* 調査書種別が純増、S＆B（B店）の場合のときにアスタリスクを表示 */}
                                {(selectedSurveyType === "01" ||
                                    selectedSurveyType === "10" ||
                                    selectedSurveyType === "02" ||
                                    selectedSurveyType === "03" ||
                                    selectedSurveyType === "04") && (
                                        <RedAsterisk sx={{ whiteSpace: "nowrap" }}>
                                            ＊
                                        </RedAsterisk>
                                    )}
                            </Box>
                        </Grid>
                        <Grid>
                            <LongTextFiledWithIcons
                                props={{
                                    userType: userType, //ユーザー
                                    disabled: setPermissionFunc(
                                        userType,
                                        objLocationBase.task_id,
                                        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                        "setting_reason"
                                    ), //ユーザー権限
                                    pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                    labelName: "setting_reason",
                                    rows: 3, //ロングテキストの行数 全角180文字
                                    width: "1000px", //テキストフィールドの幅
                                    InputValueObj: props.storeOpeningConditions,
                                    ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                    setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                    ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                    ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                    handleChatBubbleClick: handleChatBubbleClick,
                                    handleInputBlur: handleInputBlur,
                                    handleInputChange: handleInputChange,
                                    handleInputClick: handleInputClick,
                                    handleKeyDown: handleKeyDown,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={3} maxWidth="lg">
                <Grid xs={12}>
                    <Grid container spacing={3} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "120px",
                                }}
                            >
                                <Typography>候補地跡地</Typography>
                                {/* 調査書種別が純増の場合のときにアスタリスクを表示 */}
                                {(selectedSurveyType === "01" ||
                                    selectedSurveyType === "10" ||
                                    selectedSurveyType === "04") && (
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    )}
                            </Box>
                        </Grid>
                        <Box display="flex" alignItems="center">
                            <Grid sx={{ width: "200px" }}>
                                <FormControl fullWidth>
                                    <Select
                                        onChange={(e) => handleSelectChange(e, "candidate_location_ruins")}
                                        value={objStoreOpeningConditions.candidate_location_ruins}
                                        sx={selectStyle(
                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                ? setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    "candidate_location_ruins"
                                                )
                                                : storeOpeningConditionsReadOnlyObj.candidate_location_ruins,
                                            objRrBranchLog,
                                            objRequestErrorList,
                                            listDeficiencyComment,
                                            "candidate_location_ruins",
                                            objStoreOpeningConditions.candidate_location_ruins,
                                            objLocationBase
                                        )}
                                        disabled={
                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                ? setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    "candidate_location_ruins"
                                                )
                                                : storeOpeningConditionsReadOnlyObj.candidate_location_ruins
                                        }
                                    >
                                        {Object.keys(
                                            candidateLocationRuinsItems
                                        ).map((key) => (
                                            <MenuItem
                                                key={key}
                                                value={candidateLocationRuinsItems[key]}
                                            >
                                                {candidateLocationRuinsItems[key]}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                            {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                            {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                <Grid sx={{ width: "200px" }}>
                                    <IconButton
                                        disabled={setPermissionFunc(
                                            userType,
                                            objLocationBase.task_id,
                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            "candidate_location_ruins"
                                        )}
                                        onClick={() => {handleChatBubbleClick("candidate_location_ruins");}}
                                        sx={iconHover}
                                    >
                                        <Box
                                            sx={chatBubbleErrorSx(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "candidate_location_ruins",
                                                listDeficiencyComment
                                            )}
                                        >
                                            <ChatBubbleIcon
                                                sx={chatBubbleIconSx}
                                            />
                                        </Box>
                                    </IconButton>
                                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                        <IconButton
                                            onClick={() => {handleEditIconClick("candidate_location_ruins");}}
                                            sx={iconHover}
                                        >
                                            <Box sx={editIconCircleSx}>
                                                <EditIcon />
                                            </Box>
                                        </IconButton>
                                    )}
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            {/* 候補地跡地のプルダウンで選択した場合ロングテキストを表示 */}
            {objLongTextShow.candidate_location_ruins && (
                <>
                    <Grid container spacing={2}>
                        <Grid xs={12}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "120px",
                                        }}
                                    >
                                        <Typography
                                            sx={{ width: "80px" }}
                                        ></Typography>
                                    </Box>
                                </Grid>
                                <Grid>
                                    <Box>
                                        <Typography>
                                            ①撤退理由 ②撤退・開店予定日
                                            ③活性化策の具体的な内容を記載
                                        </Typography>
                                        <Typography>
                                            ※競合看板替えの場合は現行契約が「普通」ｏｒ「定期」を明記
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid xs={12}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "120px",
                                        }}
                                    >
                                        <Typography
                                            sx={{ width: "80px" }}
                                        ></Typography>
                                        {/* 調査書種別が純増の場合のときにアスタリスクを表示 */}
                                        {(selectedSurveyType === "01" ||
                                            selectedSurveyType === "10" ||
                                            selectedSurveyType === "04") && (
                                                <RedAsterisk>＊＊</RedAsterisk>
                                            )}
                                    </Box>
                                </Grid>
                                <Grid>
                                    <LongTextFiledWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "candidate_location_ruins_long_text"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "candidate_location_ruins_long_text",
                                            rows: 2, //ロングテキストの行数 全角120文字
                                            width: "1000px", //テキストフィールドの幅
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange:   handleInputChange,
                                            handleInputClick: handleInputClick,
                                            handleKeyDown: handleKeyDown,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            )}

            <Typography component="h2" mt={2}>
                ２．店名選定の理由について
            </Typography>

            <Grid container spacing={2}>
                <Grid xs={12}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "95px",
                                    paddingLeft: "50px",
                                }}
                            ></Box>
                        </Grid>
                        <Box display="flex" alignItems="center">
                            <Grid>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            onChange={(e) => handleCheckBoxChange(e, "is_store_name_select_reason")}
                                            checked={objStoreOpeningConditions.is_store_name_select_reason}
                                            disabled={
                                                userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                    ? setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                        "is_store_name_select_reason"
                                                    )
                                                    : storeOpeningConditionsReadOnlyObj.is_store_name_select_reason
                                            }
                                        ></Checkbox>
                                    }
                                    sx={checkboxStyle(
                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                            ? setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "is_store_name_select_reason"
                                            )
                                            : storeOpeningConditionsReadOnlyObj.is_store_name_select_reason,
                                        objRrBranchLog,
                                        objRequestErrorList,
                                        "is_store_name_select_reason",
                                        objStoreOpeningConditions.is_store_name_select_reason
                                    )}
                                    label="所在地表示以外にて選定（選定根拠を下記に記載）"
                                />
                            </Grid>
                            {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                            {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                            {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                <Grid sx={{ width: "200px" }}>
                                    <IconButton
                                        disabled={setPermissionFunc(
                                            userType,
                                            objLocationBase.task_id,
                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            "is_store_name_select_reason"
                                        )}
                                        onClick={() => {handleChatBubbleClick("is_store_name_select_reason");}}
                                        sx={iconHover}
                                    >
                                        <Box
                                            sx={chatBubbleErrorSx(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "is_store_name_select_reason",
                                                listDeficiencyComment
                                            )}
                                        >
                                            <ChatBubbleIcon
                                                sx={chatBubbleIconSx}
                                            />
                                        </Box>
                                    </IconButton>
                                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                        <IconButton
                                            onClick={() => {handleEditIconClick("is_store_name_select_reason");}}
                                            sx={iconHover}
                                        >
                                            <Box sx={editIconCircleSx}>
                                                <EditIcon />
                                            </Box>
                                        </IconButton>
                                    )}
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            {/* 所在地表示以外にて選定にチェックを入れた時　下にロングテキストを表示 */}
            {objLongTextShow.removal_Reason && (
                <Grid container spacing={2}>
                    <Grid xs={12}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: "95px",
                                        paddingLeft: "50px",
                                    }}
                                >
                                    {/* 調査書種別が純増、S＆B（B店）、セットバック（改造後）、立地評価（タイプ変更後）の場合のときにアスタリスクを表示 */}
                                    {(selectedSurveyType === "01" ||
                                        selectedSurveyType === "10" ||
                                        selectedSurveyType === "02" ||
                                        selectedSurveyType === "03" ||
                                        selectedSurveyType === "04") && (
                                            <RedAsterisk>＊＊</RedAsterisk>
                                        )}
                                </Box>
                            </Grid>
                            <Grid>
                                <LongTextFiledWithIcons
                                    props={{
                                        userType: userType, //ユーザー
                                        disabled: setPermissionFunc(
                                            userType,
                                            objLocationBase.task_id,
                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            "removal_Reason"
                                        ), //ユーザー権限
                                        pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                        labelName: "removal_Reason",
                                        rows: 2, //ロングテキストの行数 全角120文字
                                        width: "1000px", //テキストフィールドの幅
                                        InputValueObj: props.storeOpeningConditions,
                                        ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                        setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                        ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                        ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                        handleChatBubbleClick: handleChatBubbleClick,
                                        handleInputBlur: handleInputBlur,
                                        handleInputChange: handleInputChange,
                                        handleInputClick: handleInputClick,
                                        handleKeyDown: handleKeyDown,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}

            {/* 営業条件 */}
            <Typography component="h2" mt={2}>
                営業条件
            </Typography>

            <Grid container spacing={2} maxWidth="lg">
                <Grid xs={12}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "120px",
                                }}
                            >
                                <Typography>24時間営業</Typography>
                                <RedAsterisk>＊</RedAsterisk>
                            </Box>
                        </Grid>
                        <Box display="flex" alignItems="center">
                            <Grid sx={itemValueSx}>
                                <FormControl fullWidth>
                                    <Select
                                        onChange={(e) => handleSelectChange(e, "open24_hours")}
                                        value={objStoreOpeningConditions.open24_hours}
                                        sx={selectMonthStyle(
                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                ? setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    "open24_hours"
                                                )
                                                : storeOpeningConditionsReadOnlyObj.open24_hours,
                                            objRrBranchLog,
                                            objRequestErrorList,
                                            listDeficiencyComment,
                                            "open24_hours",
                                            objStoreOpeningConditions.open24_hours
                                        )}
                                        startAdornment={
                                            <InputAdornment position="start">
                                                {LOCAL_CONSTANT.LABEL.YES}
                                            </InputAdornment>
                                        }
                                        endAdornment={
                                            <InputAdornment position="end">
                                                {LOCAL_CONSTANT.LABEL.MONTHS}
                                            </InputAdornment>
                                        }
                                        disabled={
                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                ? setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    "open24_hours"
                                                )
                                                : storeOpeningConditionsReadOnlyObj.open24_hours
                                        }
                                    >
                                        {Object.keys(monthItems).map((key) => (
                                            <MenuItem key={key} value={monthItems[key]}>
                                                {monthItems[key]}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid sx={itemValueSx}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={String(12 - Number(objStoreOpeningConditions.open24_hours))}
                                    sx={inactiveBlueTextSx(
                                        objRrBranchLog,
                                        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                        "not_open24_hours"
                                    )}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                {LOCAL_CONSTANT.LABEL.NOTHING}
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {LOCAL_CONSTANT.LABEL.MONTHS}
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                />
                            </Grid>
                            {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                            {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                            {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                <Grid sx={{ width: "200px" }}>
                                    <IconButton
                                        disabled={setPermissionFunc(
                                            userType,
                                            objLocationBase.task_id,
                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            "open24_hours"
                                        )}
                                        onClick={() => {handleChatBubbleClick("open24_hours");}}
                                        sx={iconHover}
                                    >
                                        <Box
                                            sx={chatBubbleErrorSx(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "open24_hours",
                                                listDeficiencyComment
                                            )}
                                        >
                                            <ChatBubbleIcon
                                                sx={chatBubbleIconSx}
                                            />
                                        </Box>
                                    </IconButton>
                                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                        <IconButton
                                            onClick={() => {handleEditIconClick("open24_hours");}}
                                            sx={iconHover}
                                        >
                                            <Box sx={editIconCircleSx}>
                                                <EditIcon />
                                            </Box>
                                        </IconButton>
                                    )}
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={2} maxWidth="lg">
                <Grid xs={12}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "120px",
                                }}
                            >
                                <Typography>酒免許</Typography>
                                <RedAsterisk>＊</RedAsterisk>
                            </Box>
                        </Grid>
                        <Box display="flex" alignItems="center">
                            <Grid sx={itemValueSx}>
                                <FormControl fullWidth>
                                    <Select
                                        onChange={(e) => handleSelectChange(e, "alcohol_license")}
                                        value={objStoreOpeningConditions.alcohol_license}
                                        sx={selectMonthStyle(
                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                ? setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    "alcohol_license"
                                                )
                                                : storeOpeningConditionsReadOnlyObj.alcohol_license,
                                            objRrBranchLog,
                                            objRequestErrorList,
                                            listDeficiencyComment,
                                            "alcohol_license",
                                            objStoreOpeningConditions.alcohol_license
                                        )}
                                        startAdornment={
                                            <InputAdornment position="start">
                                                {LOCAL_CONSTANT.LABEL.YES}
                                            </InputAdornment>
                                        }
                                        endAdornment={
                                            <InputAdornment position="end">
                                                {LOCAL_CONSTANT.LABEL.MONTHS}
                                            </InputAdornment>
                                        }
                                        disabled={
                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                ? setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    "alcohol_license"
                                                )
                                                : storeOpeningConditionsReadOnlyObj.alcohol_license
                                        }
                                    >
                                        {Object.keys(monthItems).map((key) => (
                                            <MenuItem key={key} value={monthItems[key]}>
                                                {monthItems[key]}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid sx={itemValueSx}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={String(12 - Number(objStoreOpeningConditions.alcohol_license))}
                                    sx={inactiveBlueTextSx(
                                        objRrBranchLog,
                                        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                        "no_alcohol_license"
                                    )}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                {LOCAL_CONSTANT.LABEL.NOTHING}
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {LOCAL_CONSTANT.LABEL.MONTHS}
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                />
                            </Grid>
                            {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                            {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                            {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                <Grid sx={{ width: "200px" }}>
                                    <IconButton
                                        disabled={setPermissionFunc(
                                            userType,
                                            objLocationBase.task_id,
                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            "alcohol_license"
                                        )}
                                        onClick={() => {handleChatBubbleClick("alcohol_license");}}
                                        sx={iconHover}
                                    >
                                        <Box
                                            sx={chatBubbleErrorSx(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "alcohol_license",
                                                listDeficiencyComment
                                            )}
                                        >
                                            <ChatBubbleIcon
                                                sx={chatBubbleIconSx}
                                            />
                                        </Box>
                                    </IconButton>
                                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                        <IconButton
                                            onClick={() => {handleEditIconClick("alcohol_license");}}
                                            sx={iconHover}
                                        >
                                            <Box sx={editIconCircleSx}>
                                                <EditIcon />
                                            </Box>
                                        </IconButton>
                                    )}
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={2} maxWidth="lg">
                <Grid xs={12}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "120px",
                                }}
                            >
                                <Typography>煙草免許</Typography>
                                <RedAsterisk>＊</RedAsterisk>
                            </Box>
                        </Grid>
                        <Box display="flex" alignItems="center">
                            <Grid sx={itemValueSx}>
                                <FormControl fullWidth>
                                    <Select
                                        onChange={(e) => handleSelectChange(e,"tobacco_licence")}
                                        value={objStoreOpeningConditions.tobacco_licence}
                                        sx={selectMonthStyle(
                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                ? setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    "tobacco_licence"
                                                )
                                                : storeOpeningConditionsReadOnlyObj.tobacco_licence,
                                            objRrBranchLog,
                                            objRequestErrorList,
                                            listDeficiencyComment,
                                            "tobacco_licence",
                                            objStoreOpeningConditions.tobacco_licence
                                        )}
                                        startAdornment={
                                            <InputAdornment position="start">
                                                {LOCAL_CONSTANT.LABEL.YES}
                                            </InputAdornment>
                                        }
                                        endAdornment={
                                            <InputAdornment position="end">
                                                {LOCAL_CONSTANT.LABEL.MONTHS}
                                            </InputAdornment>
                                        }
                                        disabled={
                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                ? setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    "tobacco_licence"
                                                )
                                                : storeOpeningConditionsReadOnlyObj.tobacco_licence
                                        }
                                    >
                                        {Object.keys(monthItems).map((key) => (
                                            <MenuItem key={key} value={monthItems[key]}>
                                                {monthItems[key]}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid sx={itemValueSx}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={String(12 - Number(objStoreOpeningConditions.tobacco_licence))}
                                    sx={inactiveBlueTextSx(
                                        objRrBranchLog,
                                        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                        "no_tobacco_licence"
                                    )}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                {LOCAL_CONSTANT.LABEL.NOTHING}
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {LOCAL_CONSTANT.LABEL.MONTHS}
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                />
                            </Grid>
                            {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                            {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                            {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                <Grid sx={{ width: "200px" }}>
                                    <IconButton
                                        disabled={setPermissionFunc(
                                            userType,
                                            objLocationBase.task_id,
                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            "tobacco_licence"
                                        )}
                                        onClick={() => {handleChatBubbleClick("tobacco_licence");}}
                                        sx={iconHover}
                                    >
                                        <Box
                                            sx={chatBubbleErrorSx(                                    
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "tobacco_licence",
                                                listDeficiencyComment
                                            )}
                                        >
                                            <ChatBubbleIcon
                                                sx={chatBubbleIconSx}
                                            />
                                        </Box>
                                    </IconButton>
                                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                        <IconButton
                                            onClick={() => {handleEditIconClick("tobacco_licence");}}
                                            sx={iconHover}
                                        >
                                            <Box sx={editIconCircleSx}>
                                                <EditIcon />
                                            </Box>
                                        </IconButton>
                                    )}
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            {/* 空行を入れる */}
            <Grid container maxWidth="lg">
                <Grid xs={12} height={30}></Grid>
            </Grid>

            <Grid container spacing={2} maxWidth="lg">
                <Grid xs={12} md={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "120px",
                                }}
                            >
                                <Typography>地域区分</Typography>
                                {/* 調査書種別が純増、セットバック（改造後）、立地評価（タイプ変更後）、S＆B（B店）の場合のときにアスタリスクを表示 */}
                                {(selectedSurveyType === "01" ||
                                    selectedSurveyType === "10" ||
                                    selectedSurveyType === "02" ||
                                    selectedSurveyType === "03" ||
                                    selectedSurveyType === "04") && (
                                        <RedAsterisk>＊</RedAsterisk>
                                    )}
                            </Box>
                        </Grid>
                        <Box display="flex" alignItems="center">
                            <Grid sx={itemValueSx}>
                                <FormControl fullWidth>
                                    <Select
                                        onChange={(e) => handleSelectChange(e, "area_type")}
                                        value={objStoreOpeningConditions.area_type}
                                        disabled={
                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                ? setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    "area_type"
                                                )
                                                : storeOpeningConditionsReadOnlyObj.area_type
                                        }
                                        sx={selectStyle(
                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                ? setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    "area_type"
                                                )
                                                : storeOpeningConditionsReadOnlyObj.area_type,
                                            objRrBranchLog,
                                            objRequestErrorList,
                                            listDeficiencyComment,
                                            "area_type",
                                            objStoreOpeningConditions.area_type,
                                            objLocationBase
                                        )}
                                    >
                                        {Object.keys(areaTypeItems).map(
                                            (key) => (
                                                <MenuItem key={key} value={areaTypeItems[key]}>
                                                    {areaTypeItems[key]}
                                                </MenuItem>
                                            )
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                            {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                            {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                <Grid sx={{ width: "200px" }}>
                                    <IconButton
                                        disabled={setPermissionFunc(
                                            userType,
                                            objLocationBase.task_id,
                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            "area_type"
                                        )}
                                        onClick={() => {handleChatBubbleClick("area_type");}}
                                        sx={iconHover}
                                    >
                                        <Box
                                            sx={chatBubbleErrorSx(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "area_type",
                                                listDeficiencyComment
                                            )}
                                        >
                                            <ChatBubbleIcon
                                                sx={chatBubbleIconSx}
                                            />
                                        </Box>
                                    </IconButton>
                                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                        <IconButton
                                            onClick={() => {handleEditIconClick("area_type");}}
                                            sx={iconHover}
                                        >
                                            <Box sx={editIconCircleSx}>
                                                <EditIcon />
                                            </Box>
                                        </IconButton>
                                        )}
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                </Grid>
                <Grid xs={12} md={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "140px",
                                }}
                            >
                                <Typography>最寄り既設店までの距離</Typography>
                                {/* 調査書種別が純増、セットバック（改造後）、立地評価（タイプ変更後）、S＆B（B店）の場合のときにアスタリスクを表示 */}
                                {(selectedSurveyType === "01" ||
                                    selectedSurveyType === "10" ||
                                    selectedSurveyType === "02" ||
                                    selectedSurveyType === "03" ||
                                    selectedSurveyType === "04") && (
                                        <RedAsterisk>＊</RedAsterisk>
                                    )}
                            </Box>
                        </Grid>
                        <Grid sx={itemValueSx}>
                            <InputWithIcons
                                props={{
                                    userType: userType, //ユーザー
                                    disabled: setPermissionFunc(
                                        userType,
                                        objLocationBase.task_id,
                                        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                        "nearest_already_store_distance"
                                    ), //ユーザー権限
                                    pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                    labelName: "nearest_already_store_distance",
                                    startAdornment: "",
                                    endAdornment: "m",
                                    InputValueObj: props.storeOpeningConditions,
                                    ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                    setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                    ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                    ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                    handleChatBubbleClick: handleChatBubbleClick,
                                    handleInputBlur: handleInputBlur,
                                    handleInputChange: handleInputChange,
                                    handleInputClick: handleInputClick,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={2} maxWidth="lg">
                <Grid xs={12} md={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "120px",
                                }}
                            >
                                <Typography>環境区分</Typography>
                                {/* 調査書種別が純増、セットバック（改造後）、立地評価（タイプ変更後）、S＆B（B店）の場合のときにアスタリスクを表示 */}
                                {(selectedSurveyType === "01" ||
                                    selectedSurveyType === "10" ||
                                    selectedSurveyType === "02" ||
                                    selectedSurveyType === "03" ||
                                    selectedSurveyType === "04") && (
                                        <RedAsterisk>＊</RedAsterisk>
                                    )}
                            </Box>
                        </Grid>
                        <Box display="flex" alignItems="center">
                            <Grid sx={itemValueSx}>
                                <FormControl fullWidth>
                                    <Select
                                        onChange={(e) => handleSelectChange(e, "environment_type")}
                                        value={objStoreOpeningConditions.environment_type}
                                        disabled={
                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                ? setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    "environment_type"
                                                )
                                                : storeOpeningConditionsReadOnlyObj.environment_type
                                        }
                                        sx={selectStyle(
                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                ? setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    "environment_type"
                                                )
                                                : storeOpeningConditionsReadOnlyObj.environment_type,
                                            objRrBranchLog,
                                            objRequestErrorList,
                                            listDeficiencyComment,
                                            "environment_type",
                                            objStoreOpeningConditions.environment_type,
                                            objLocationBase
                                        )}
                                    >
                                        {environmentType?.map((row: any) => (
                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                {row.code_display}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                            {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                            {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                <Grid sx={{ width: "200px" }}>
                                    <IconButton
                                        disabled={setPermissionFunc(
                                            userType,
                                            objLocationBase.task_id,
                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            "environment_type"
                                        )}
                                        onClick={() => {handleChatBubbleClick("environment_type");}}
                                        sx={iconHover}
                                    >
                                        <Box
                                            sx={chatBubbleErrorSx(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "environment_type",
                                                listDeficiencyComment
                                            )}
                                        >
                                            <ChatBubbleIcon
                                                sx={chatBubbleIconSx}
                                            />
                                        </Box>
                                    </IconButton>
                                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                        <IconButton
                                            onClick={() => {handleEditIconClick("environment_type");}}
                                            sx={iconHover}
                                        >
                                            <Box sx={editIconCircleSx}>
                                                <EditIcon />
                                            </Box>
                                        </IconButton>
                                    )}
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                </Grid>
                <Grid xs={12} md={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "140px",
                                }}
                            >
                                <Typography>取得要件</Typography>
                                {/* 調査書種別が純増、S＆B（B店）、セットバック（改造後）、立地評価（タイプ変更後）の場合のときにアスタリスクを表示 */}
                                {(selectedSurveyType === "01" ||
                                    selectedSurveyType === "10" ||
                                    selectedSurveyType === "02" ||
                                    selectedSurveyType === "03" ||
                                    selectedSurveyType === "04") &&
                                    isAcquisitionRequirement === false && (
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    )}
                            </Box>
                        </Grid>
                        <Box display="flex" alignItems="center">
                            <Grid sx={itemValueSx}>
                                <FormControl fullWidth>
                                    <Select
                                        onChange={(e) => handleSelectChange(e,"acquisition_requirement")}   
                                        value={objStoreOpeningConditions.acquisition_requirement}
                                        disabled={isAcquisitionRequirement}
                                        sx={selectStyle(
                                            isAcquisitionRequirement,
                                            objRrBranchLog,
                                            objRequestErrorList,
                                            listDeficiencyComment,
                                            "acquisition_requirement",
                                            objStoreOpeningConditions.acquisition_requirement,
                                            objLocationBase
                                        )}
                                    >
                                        {acquisitionRequirement?.map(
                                            (row: any) => (
                                                <MenuItem key={row.code_value} value={row.code_value}>
                                                    {row.code_display}
                                                </MenuItem>
                                            )
                                        )}
                                        {/* プルダウンに空欄を追加 */}
                                        <MenuItem value="">　</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                            {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                            {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                <Grid sx={{ width: "150px" }}>
                                    <IconButton
                                        disabled={setPermissionFunc(
                                            userType,
                                            objLocationBase.task_id,
                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            "acquisition_requirement"
                                        )}
                                        onClick={() => {handleChatBubbleClick("acquisition_requirement");}}
                                        sx={iconHover}
                                    >
                                        <Box
                                            sx={chatBubbleErrorSx(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "acquisition_requirement",
                                                listDeficiencyComment
                                            )}
                                        >
                                            <ChatBubbleIcon
                                                sx={chatBubbleIconSx}
                                            />
                                        </Box>
                                    </IconButton>
                                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                        <IconButton
                                            onClick={() => {handleEditIconClick("acquisition_requirement");}}
                                            sx={iconHover}
                                        >
                                            <Box sx={editIconCircleSx}>
                                                <EditIcon />
                                            </Box>
                                        </IconButton>
                                    )}
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={2} maxWidth="lg">
                <Grid xs={12} md={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "120px",
                                }}
                            >
                                <Typography>煙草距離基準</Typography>
                                {/* 調査書種別が純増、セットバック（改造後）、立地評価（タイプ変更後）、S＆B（B店）の場合のときにアスタリスクを表示 */}
                                {(selectedSurveyType === "01" ||
                                    selectedSurveyType === "10" ||
                                    selectedSurveyType === "02" ||
                                    selectedSurveyType === "03" ||
                                    selectedSurveyType === "04") && (
                                        <RedAsterisk>＊</RedAsterisk>
                                    )}
                            </Box>
                        </Grid>
                        <Grid sx={itemValueSx}>
                            <TextField
                                fullWidth
                                disabled={true}
                                value={
                                    objStoreOpeningConditions.tobacco_distance_standard
                                }
                                sx={inactiveBlueTextSx(
                                    objRrBranchLog,
                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                    "tobacco_distance_standard"
                                )}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start"></InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            m
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs={12} md={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "140px",
                                }}
                            >
                                <Typography width={100}>
                                    距離基準内の既設店舗数
                                </Typography>
                                {/* 調査書種別が純増、セットバック（改造後）、立地評価（タイプ変更後）、S＆B（B店）の場合のときにアスタリスクを表示 */}
                                {(selectedSurveyType === "01" ||
                                    selectedSurveyType === "10" ||
                                    selectedSurveyType === "02" ||
                                    selectedSurveyType === "03" ||
                                    selectedSurveyType === "04") && (
                                        <RedAsterisk>＊</RedAsterisk>
                                    )}
                            </Box>
                        </Grid>
                        <Grid sx={itemValueSx}>
                            <InputWithIcons
                                props={{
                                    userType: userType, //ユーザー
                                    disabled: setPermissionFunc(
                                        userType,
                                        objLocationBase.task_id,
                                        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                        "distance_standard_alreadystore_count"
                                    ), //ユーザー権限
                                    pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                    labelName: "distance_standard_alreadystore_count",
                                    startAdornment: "",
                                    endAdornment: "",
                                    InputValueObj: props.storeOpeningConditions,
                                    ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                    setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                    ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                    ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                    handleChatBubbleClick: handleChatBubbleClick,
                                    handleInputBlur: handleInputBlur,
                                    handleInputChange: handleInputChange,
                                    handleInputClick: handleInputClick,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {/* 前職 */}
            <Typography component="h2" mt={2}>
                前職
            </Typography>

            <Grid container spacing={2} maxWidth="lg">
                <Grid xs={12} md={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Typography width={120}>前職</Typography>
                        </Grid>
                        <Box display="flex" alignItems="center">
                            <Grid sx={itemValueSx}>
                                {objStoreOpeningConditions.previous_job ===
                                    "0" ||
                                    objStoreOpeningConditions.previous_job ===
                                    "1" ? (
                                    <TextField
                                        fullWidth
                                        disabled
                                        value={
                                            objStoreOpeningConditions.previous_job ===
                                                "0"
                                                ? previousJob?.[0].code_display
                                                : previousJob?.[1].code_display
                                        }
                                        sx={inactiveBlueTextSx(
                                            objRrBranchLog,
                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            "previous_job"
                                        )}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start"></InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment position="end"></InputAdornment>
                                            ),
                                        }}
                                        variant="outlined"
                                    />
                                ) : (
                                    <TextField
                                        fullWidth
                                        sx={inactiveTextSx}
                                        value=""
                                        InputProps={{
                                            readOnly: true,
                                            startAdornment: (
                                                <InputAdornment position="start"></InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment position="end"></InputAdornment>
                                            ),
                                        }}
                                        variant="filled"
                                    />
                                )}
                            </Grid>
                            {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                            {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                            {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                <Grid sx={{ width: "200px" }}>
                                    <IconButton
                                        disabled={setPermissionFunc(
                                            userType,
                                            objLocationBase.task_id,
                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            "store_move_type"
                                        )}
                                        onClick={() => {handleChatBubbleClick("store_move_type");}}
                                        sx={iconHover}
                                    >
                                        <Box
                                            sx={chatBubbleErrorSx(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "store_move_type",
                                                listDeficiencyComment
                                            )}
                                        >
                                            <ChatBubbleIcon
                                                sx={chatBubbleIconSx}
                                            />
                                        </Box>
                                    </IconButton>
                                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                        <IconButton
                                            onClick={() => {handleEditIconClick("store_move_type");}}
                                            sx={iconHover}
                                        >
                                            <Box sx={editIconCircleSx}>
                                                <EditIcon />
                                            </Box>
                                        </IconButton>
                                    )}
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                </Grid>
                <Grid xs={12} md={6}></Grid>
            </Grid>

            {showPreviousJob && (
                <Box>
                    <Grid container spacing={2} maxWidth="lg">
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "120px",
                                        }}
                                    >
                                        <Typography>元競合CVS</Typography>
                                        {/* 調査書種別が純増、セットバック（改造後）、立地評価（タイプ変更後）、S＆B（B店）の場合のときにアスタリスクを表示 */}
                                        {(selectedSurveyType === "01" ||
                                            selectedSurveyType === "10" ||
                                            selectedSurveyType === "02" ||
                                            selectedSurveyType === "03" ||
                                            selectedSurveyType === "04") && (
                                                <RedAsterisk>＊＊</RedAsterisk>
                                            )}
                                    </Box>
                                </Grid>
                                <Grid sx={itemValueSx}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "conflict_cvs"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "conflict_cvs",
                                            startAdornment: "",
                                            endAdornment: "",
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "140px",
                                        }}
                                    >
                                        <Typography width={100}>
                                            CVS 直近日販
                                        </Typography>
                                        {/* 調査書種別が純増、セットバック（改造後）、立地評価（タイプ変更後）、S＆B（B店）の場合のときにアスタリスクを表示 */}
                                        {(selectedSurveyType === "01" ||
                                            selectedSurveyType === "10" ||
                                            selectedSurveyType === "02" ||
                                            selectedSurveyType === "03" ||
                                            selectedSurveyType === "04") && (
                                                <RedAsterisk>＊＊</RedAsterisk>
                                            )}
                                    </Box>
                                </Grid>
                                <Grid sx={itemValueSx}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "cvs_last_nippan"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "cvs_last_nippan",
                                            startAdornment: "",
                                            endAdornment: "万円",
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            )}

            {/* 前職が「セブン-イレブン店」（上の候補地跡地が自社建て替え、自社跡地の時）の時のみ、プルダウンと距離を表示 */}
            {objStoreOpeningConditions.previous_job === "1" && (
                <Grid container spacing={2}>
                    <Grid xs={12} md={6}>
                        <Grid container spacing={2}>
                            <Grid>
                                <Typography width={120}></Typography>
                            </Grid>
                            <Grid>
                                <FormControl>
                                    <RadioGroup
                                        value={objStoreOpeningConditions.store_move_type}
                                        onChange={(e) => handleRadioButtonChange(e,"store_move_type")}
                                    >
                                        <FormControlLabel
                                            sx={{ width: "110px" }}
                                            value={
                                                storeMoveType?.[0].code_value
                                            }
                                            control={
                                                <Radio
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                                "store_move_type"
                                                            )
                                                            : storeOpeningConditionsReadOnlyObj.store_move_type
                                                    }
                                                    sx={radioStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                                "store_move_type"
                                                            )
                                                            : storeOpeningConditionsReadOnlyObj.store_move_type
                                                    )}
                                                />
                                            }
                                            label={storeMoveType?.[0].code_display}
                                        />
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <FormControlLabel
                                                sx={{ width: "110px" }}
                                                value={storeMoveType?.[1].code_value}
                                                control={
                                                    <Radio
                                                        disabled={
                                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                                ? setPermissionFunc(
                                                                    userType,
                                                                    objLocationBase.task_id,
                                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                                    "store_move_type"
                                                                )
                                                                : storeOpeningConditionsReadOnlyObj.store_move_type
                                                        }
                                                        sx={radioStyle(
                                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                                ? setPermissionFunc(
                                                                    userType,
                                                                    objLocationBase.task_id,
                                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                                    "store_move_type"
                                                                )
                                                                : storeOpeningConditionsReadOnlyObj.store_move_type
                                                        )}
                                                    />
                                                }
                                                label={storeMoveType?.[1].code_display}
                                            />
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: isStoreMoveDistance, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    labelName: "store_move_distance",
                                                    startAdornment: "",
                                                    endAdornment: "m",
                                                    InputValueObj: props.storeOpeningConditions,
                                                    ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                                    setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                                    ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                                    ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        </Box>
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}

            {/* その他 */}
            <Typography component="h2" mt={2}>
                その他
            </Typography>

            <Grid container spacing={2} maxWidth="lg">
                <Grid xs={12}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100px",
                                }}
                            >
                                <Typography>所有形態</Typography>
                                <RedAsterisk>＊</RedAsterisk>
                            </Box>
                        </Grid>
                        <Box display="flex" alignItems="center">
                            <Grid>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        value={objStoreOpeningConditions.ownership_type}
                                        onChange={(e) => handleRadioButtonChange(e, "ownership_type")}
                                    >
                                        <FormControlLabel
                                            sx={{ width: "110px" }}
                                            value={ownershipType?.[0].code_value}
                                            control={
                                                <Radio
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                                "ownership_type"
                                                            )
                                                            : storeOpeningConditionsReadOnlyObj.ownership_type
                                                    }
                                                    sx={radioStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                                "ownership_type"
                                                            )
                                                            : storeOpeningConditionsReadOnlyObj.ownership_type
                                                    )}
                                                />
                                            }
                                            label={ownershipType?.[0].code_display}
                                        />
                                        <FormControlLabel
                                            value={ownershipType?.[1].code_value}
                                            control={
                                                <Radio
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                                "ownership_type"
                                                            )
                                                            : storeOpeningConditionsReadOnlyObj.ownership_type
                                                    }
                                                    sx={radioStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                                "ownership_type"
                                                            )
                                                            : storeOpeningConditionsReadOnlyObj.ownership_type
                                                    )}
                                                />
                                            }
                                            label={ownershipType?.[1].code_display}
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                            {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                            {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                <Grid sx={{ width: "200px" }}>
                                    <IconButton
                                        disabled={setPermissionFunc(
                                            userType,
                                            objLocationBase.task_id,
                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            "ownership_type"
                                        )}
                                        onClick={() => {handleChatBubbleClick("ownership_type");}}
                                        sx={iconHover}
                                    >
                                        <Box
                                            sx={chatBubbleErrorSx(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "ownership_type",
                                                listDeficiencyComment
                                            )}
                                        >
                                            <ChatBubbleIcon
                                                sx={chatBubbleIconSx}
                                            />
                                        </Box>
                                    </IconButton>
                                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                        <IconButton
                                            onClick={() => {handleEditIconClick("ownership_type");}}
                                            sx={iconHover}
                                        >
                                            <Box sx={editIconCircleSx}>
                                                <EditIcon />
                                            </Box>
                                        </IconButton>
                                    )}
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={2} maxWidth="lg">
                <Grid xs={12}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100px",
                                }}
                            >
                                <Typography>店舗形態</Typography>
                                <RedAsterisk>＊</RedAsterisk>
                            </Box>
                        </Grid>
                        <Box display="flex" alignItems="center">
                            <Grid>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        value={objStoreOpeningConditions.store_type}
                                        onChange={(e) => handleRadioButtonChange(e, "store_type")}
                                    >
                                        <FormControlLabel
                                            sx={{ width: "110px" }}
                                            value={storeType?.[0].code_value}
                                            control={
                                                <Radio
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                                "store_type"
                                                            )
                                                            : storeOpeningConditionsReadOnlyObj.store_type
                                                    }
                                                    sx={radioStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                                "store_type"
                                                            )
                                                            : storeOpeningConditionsReadOnlyObj.store_type
                                                    )}
                                                />
                                            }
                                            label={storeType?.[0].code_display}
                                        />
                                        <FormControlLabel
                                            value={storeType?.[1].code_value}
                                            control={
                                                <Radio
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                                "store_type"
                                                            )
                                                            : storeOpeningConditionsReadOnlyObj.store_type
                                                    }
                                                    sx={radioStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                                "store_type"
                                                            )
                                                            : storeOpeningConditionsReadOnlyObj.store_type
                                                    )}
                                                />
                                            }
                                            label={storeType?.[1].code_display}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    onChange={(e) => handleCheckBoxChange(e, "store_type_multiple_store")}
                                                    checked={objStoreOpeningConditions.store_type_multiple_store}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                                "store_type"
                                                            )
                                                            : storeOpeningConditionsReadOnlyObj.store_type
                                                    }
                                                ></Checkbox>
                                            }
                                            sx={checkboxStoreStyle(
                                                userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                    ? setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                        "store_type"
                                                    )
                                                    : storeOpeningConditionsReadOnlyObj.store_type,
                                                objRrBranchLog,
                                                "store_type_multiple_store",
                                                objStoreOpeningConditions.store_type_multiple_store
                                            )}
                                            label={storeType?.[2].code_display}
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                            {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                            {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                <Grid sx={{ width: "200px" }}>
                                    <IconButton
                                        disabled={setPermissionFunc(
                                            userType,
                                            objLocationBase.task_id,
                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            "store_type"
                                        )}
                                        onClick={() => {handleChatBubbleClick("store_type");}}
                                        sx={iconHover}
                                    >
                                        <Box
                                            sx={chatBubbleErrorSx(  
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "store_type",
                                                listDeficiencyComment
                                            )}
                                        >
                                            <ChatBubbleIcon
                                                sx={chatBubbleIconSx}
                                            />
                                        </Box>
                                    </IconButton>
                                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                        <IconButton
                                            onClick={() => {handleEditIconClick("store_type");}}
                                            sx={iconHover}
                                        >
                                            <Box sx={editIconCircleSx}>
                                                <EditIcon />
                                            </Box>
                                        </IconButton>
                                    )}
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            {/*不備コメント モーダル画面 */}
            <DeficiencyCommentRegistModal
                props={{
                    userType: userType,
                    modalOpen: deficiencyComentModalFlag,
                    setModalOpen: setDeficiencyComentModalFlag,
                    CommentTextFieldObj: storeOpeningConditionsCommentTextFieldObj,
                    tableName: LOCAL_CONSTANT.TABLE.STORE_OPENING_CONDITIONS,
                    columnName: labelNameStr,
                    subKey: LOCAL_CONSTANT.DEFICIENCY.DEFAULT_SUB_KEY,
                    handleCommentChange: handleCommentChange,
                    handleSaveComment: handleSaveComment,
                }}
            />
        </Box>
    );
};

export default SettingReason;
